import { Component, Input, Output, EventEmitter, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WorkerAgreementDetailsDto } from '../../../models/dtos/worker-agreement-details-dto';
import { WorkPatternEnum } from 'src/app/models/enums/work-pattern-enum';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { Permission } from 'src/app/common/enums';
import { Router } from '@angular/router';
import { AgreementHistoryService } from '../../services/agreement-history.service';
import { AnnexListWithDetailsResponse } from 'src/app/models/dtos/annexes/annex-list-with-details-dto';
import { PropertyHistoryEntry } from 'src/app/shared/components/property-with-history/models/property-history-entry';
import { WageHistoryEntry } from 'src/app/shared/components/wages-with-history/models/wages-with-history-entry';
import { WorkerService } from 'src/app/data/worker.service';

@Component({
  selector: 'app-worker-agreement-details-shared',
  templateUrl: './worker-agreement-details-shared.component.html',
  styleUrls: ['./worker-agreement-details-shared.component.scss'],
  standalone: false,
})
export class WorkerAgreementDetailsSharedComponent implements OnInit {
  private authService = inject(AuthService);
  private workerService = inject(WorkerService);

  @Input() agreement: WorkerAgreementDetailsDto;
  @Input() annexesData: AnnexListWithDetailsResponse | null = null;
  showBankAccountNumber$!: Observable<boolean>;

  private router = inject(Router);
  private historyService = inject(AgreementHistoryService);

  workPatternEnum = WorkPatternEnum;

  ngOnInit(): void {
    this.showBankAccountNumber$ = this.workerService
      .getBankAccountNumberConfiguration(this.agreement.WorkerId)
      .pipe(map(configuration => !configuration.IsBankAccountHidden));
  }

  get hasAssignOrderItemPermission(): boolean {
    return this.authService.hasPermission(Permission.AssignOrderToAgreement);
  }

  get showHistory(): boolean {
    return !!this.annexesData && this.annexesData.Annexes.length > 0;
  }

  get jobTitleHistory(): PropertyHistoryEntry[] {
    if (!this.annexesData) return [];
    return this.historyService.buildPropertyHistory('jobTitle', this.annexesData.WorkerAgreement, this.annexesData.Annexes);
  }

  get wagesHistory(): WageHistoryEntry[] {
    if (!this.annexesData) return [];
    return this.historyService.buildWagesHistory(this.annexesData.WorkerAgreement, this.annexesData.Annexes);
  }

  addWageCount(index: number): string {
    return index === 0 ? '' : ` ${index + 1}`;
  }

  navigateToAnnex(annexId: number): void {
    this.router.navigate([
      '/workers',
      this.agreement.WorkerId,
      'employmentType',
      this.agreement.EmploymentTypeId,
      'agreements',
      this.agreement.AgreementId,
      'annexes',
      annexId,
      'details',
    ]);
  }
}
